import { jsxs, jsx } from 'react/jsx-runtime';
import * as Headlessui from '@headlessui/react';
import classNames from 'classnames';
import { Icon } from '../../Icon/Icon.es.js';

const PopoverDropdown = ({ children, className, popupRole })=>{
    return jsxs(Headlessui.PopoverButton, {
        "aria-haspopup": popupRole,
        className: classNames('text-button', className),
        children: [
            children,
            jsx("div", {
                className: "icon-container",
                children: jsx(Icon, {
                    name: "ChevronDownSolid",
                    size: 20
                })
            })
        ]
    });
};
PopoverDropdown.displayName = 'Popover.Dropdown';

export { PopoverDropdown };
//# sourceMappingURL=Popover.Dropdown.es.js.map
